import { IoIosEye } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";
import {BsShop} from 'react-icons/bs'
import {HiHomeModern} from 'react-icons/hi2'
import {HiUserGroup} from 'react-icons/hi'
import {AiOutlineLogout} from '@react-icons/all-files/ai/AiOutlineLogout.esm'
import { HiTemplate } from "react-icons/hi";
import { IoSendSharp } from "react-icons/io5";
import { AiFillAudio } from "react-icons/ai";
import { MdMessage } from "react-icons/md";
import { FiPlus } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { FaSackDollar } from "react-icons/fa6";

export const EyeIcon = () => <IoIosEye />;
export const EyeOffIcon = () => <IoIosEyeOff />;
export const BsShopIcon = () => <BsShop />;
export const HiHomeModernIcon = () => <HiHomeModern />;
export const HiUserGroupIcon = () => <HiUserGroup />;
export const AiOutlineLogoutIcon = () => <AiOutlineLogout />;
export const HiTemplateIcon = () => <HiTemplate />;
export const IconPaymentRequest = () => <FaSackDollar />;
export const IconSendMessage = () => <IoSendSharp />;
export const IconAudio = () => <AiFillAudio />;
export const IconMessage = () => <MdMessage />;
export const IconAdd = () => <FiPlus />;
export const IconCross = () => <RxCross2 />;
